export default __webpack_public_path__ + "static/media/home_web-xs@2x.57470c86.webp";